import type { ReactNode } from 'react';
import { Group, Stack, Text, ThemeIcon } from '@mantine/core';

interface TermRowProps {
  readonly icon: ReactNode;
  readonly label: string;
  readonly children: ReactNode;
}

// Строка условия сделки: иконка в brand-кружке + заголовок + значение. Единый вид для всех блоков
// условий (превью сделки продажи/покупки, «Условия предложения», сводка). Ранее дублировался в 4 местах.
export default function TermRow({ icon, label, children }: TermRowProps) {
  return (
    <Group gap="sm" wrap="nowrap" align="flex-start">
      <ThemeIcon variant="light" color="brand" size={32} radius="md" style={{ flexShrink: 0 }}>
        {icon}
      </ThemeIcon>
      <Stack gap={4} style={{ minWidth: 0 }}>
        <Text fw={600} size="sm">
          {label}
        </Text>
        {children}
      </Stack>
    </Group>
  );
}
